import React, { Component } from 'react'
import Link from '../../utils/link'
import BedBathCar from '../bed-bath-car'
import AreaParkingZone from '../area-parking-zone'
import Fade from 'react-reveal/Fade'

class PropertyFeatureCard extends Component {

  render() {

    const { title, slug, images, propertyMeta, label, propertyType, color } = this.props

    const sold = ( propertyMeta?.commercialListingType === 'sale' && (propertyMeta?.status !== "listing" && propertyMeta?.status !== "conditional") )
    const leased = propertyMeta?.isLeased

    const postType = propertyMeta?.status === 'management' ? 'rental' : 'property'

    let pathName = `/property/${slug}-${propertyMeta?.address?.suburb?.postcode}-${propertyMeta?.id}/`

    if (propertyMeta?.addressVisibility !== 'fullAddress') {
      pathName = `/property/${propertyMeta?.id}/`
    }

    let address = [];

    let image = images?.length > 0 ? images[0].thumb_1024 : false

    if( propertyMeta?.displayAddress ) {
      address = propertyMeta?.displayAddress.split(",")
    }

    let soldPrice = ''
    if (sold) {
      soldPrice = propertyMeta.saleHistory?.length > 0 ? propertyMeta.saleHistory[0].salePrice : propertyMeta.saleDetails?.salePrice 
      soldPrice = soldPrice?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    return (
      <div className={`property-feature ${(sold || leased) ? 'property-feature--sold' : ''}`}>
        <Fade bottom distance='30px'>
          <Link to={pathName}>
            <div className='property-feature__inner'>
              <div className='property-feature__content'>

                <div className='property-feature__image'>
                  { image && <img src={image} alt={title} /> }

                  { sold &&
                    <div className={`sold-tag ${sold ? 'sold-tag--active' : ''}`}>
                      Sold
                    </div>
                  }
                  { leased &&
                    <div className={`sold-tag ${leased ? 'sold-tag--active' : ''}`}>
                      Leased
                    </div>
                  }

                </div>

                <div className='property-feature__details'>

                  <div className='property-feature__price'>

                    <p className='heading'>{ label }</p>

                    { propertyMeta.displayPrice && !propertyMeta.saleDetails?.salePrice && !sold &&
                      <p className='price'>{ propertyMeta.displayPrice }</p>
                    }
                  { sold && soldPrice && propertyMeta.id === '29539342' &&
                      <p className='price'>Contact Agent</p>
                    }
                  { sold && soldPrice && propertyMeta.id !== '29539342' &&
                      <p className='price'>${ propertyMeta.id === '26308866' ? '850,000' : soldPrice }</p>
                  }
                    { sold && !soldPrice &&
                      <p className='price'>Enquire Now</p>
                    }

                    { !propertyMeta?.displayPrice && propertyMeta?.searchPrice && postType === 'rental' &&
                      <p className='price'>${ propertyMeta?.searchPrice } p/w</p>
                    }

                  </div>

                  <div className='property-feature__address'>

                    { address?.length >= 2 &&

                      <ul className='address'>
                        <li>{ address[0] }</li>
                        <li>{ address[1] }</li>
                        { address[2] && <li>{address[2]}</li> }
                      </ul>
                    }

                    { propertyType === 'residential' &&
                      <BedBathCar color={color} carports={ propertyMeta?.carports } garages={ propertyMeta?.garages } openSpaces={ propertyMeta?.openSpaces } beds={ propertyMeta?.bed } baths={ propertyMeta?.bath } />
                    }

                    { propertyType === 'commercial' &&
                      <AreaParkingZone color={color} type={propertyMeta?.zoning} carports={ propertyMeta?.carports } garages={ propertyMeta?.garages } openSpaces={ propertyMeta?.openSpaces } landAreaValue={ propertyMeta?.landAreaValue } landAreaUnits={ propertyMeta?.landAreaUnits } floorAreaValue={ propertyMeta?.floorAreaValue } floorAreaUnits={ propertyMeta?.floorAreaUnits } />
                    }

                    { !propertyMeta?.displayPrice && propertyMeta?.searchPrice && postType === 'rental' &&
                      <p className='mobile-price'>${ propertyMeta.searchPrice } p/w</p>
                    }
                    { propertyMeta?.displayPrice && postType !== 'rental' &&
                      <p className='mobile-price'>{ propertyMeta?.displayPrice }</p>
                    }

                  </div>

                </div>
              </div>
            </div>
          </Link>
        </Fade>
      </div>
    )
  }
}

export default PropertyFeatureCard
